<div class="order-item-option" woa-touchable woa-activatable (onActivate)="optionSelected($event)">
    @if (showImage()) {
        <div class="order-item-option-image" [ngClass]="{'selected': selected()}">
            <img class="order-item-option-image-object" alt=""
                 [woa-image-cache]="image()?.id ? image() : menuModel.defaultItemImage()"
                 [ngClass]="{'emptyImg': !image()?.id && !menuModel.defaultItemImage()}">
            @if (imageOverlay()) {
                <div class="order-item-option-image-overlay">
                    @if (imageOverlay() === MenuItemImageOverlay.REMOVE) {
                        <img class="extra-group-body-option-image-overlay-remove" width="331" height="331" alt=""
                             ngSrc="assets/images/remove-extra.png"/>
                    }
                </div>
            }
        </div>
    }
    @if (showControl()) {
        <woa-selector-control class="order-item-option-selector"
                              [type]="controlType()" [selected]="selected()"
                              [disabled]="disableControl() || isUnavailable()"
                              [touched]="touchable()?.touched()"
                              (selectedChange)="onSelect.emit()"></woa-selector-control>
    }
    <div class="order-item-option-body">
        <div class="order-item-option-body-details">
            <div class="order-item-option-body-details-title" woa-activatable (onActivate)="optionSelected($event)">
                {{ title() }}
            </div>
            @if (outOfStock()) {
                <div class="order-item-option-body-details-stock">
                    {{ 'woa.label.order.outOfStock' | translate }}
                </div>
            }
            @if (!outOfStock() && atLimit()) {
                <div class="order-item-option-body-details-stock">
                    {{ 'woa.label.order.atLimit' | translate }}
                </div>
            }
            @if (!hidePrice() && (guestPrice() || price() || showEmptyPrice())) {
                <div class="order-item-option-body-details-price">
                    @if (guestPrice()) {
                        <div class="order-item-option-body-details-price-guest">
                            <div class="order-item-option-body-details-price-guest-sign">
                                {{ guestPriceSign() }}
                            </div>
                            {{ guestPriceAbs() | woaCurrency }}
                        </div>
                    }
                    @if (priceAbs() !== undefined) {
                        <div class="order-item-option-body-details-price-actual" [ngClass]="{'discounted': guestPrice()}">
                            <div class="order-item-option-body-details-price-actual-sign">
                                {{ priceSign() }}
                            </div>
                            {{ priceAbs() | woaCurrency }}
                        </div>
                    }
                </div>
            }
            <ng-content select="[slot=details]"></ng-content>
        </div>
        <div class="order-item-option-body-content" #content>
            <ng-content></ng-content>
        </div>
    </div>
</div>
